function Conditional(props) {
  if (props.condition) {
    return props.then;
  } else {
    return props.else;
  }
}

export default Conditional;
